import { render, staticRenderFns } from "./InventoryViewTable.vue?vue&type=template&id=719fd8e9&lang=pug&"
import script from "./InventoryViewTable.vue?vue&type=script&lang=js&"
export * from "./InventoryViewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports